import { getValueOrField, slideTransition } from '../../utils';
import { ENTER, EXIT, DURATION, EASING } from '../../constants';
import type { Duration, DurationType, Easing, EasingType, SlideProps, VariantsType } from '../../types';

const getEnterTiming = (duration: DurationType = 'moderate3', easing: EasingType = 'easeIn', delay?: DurationType) => ({
    duration: DURATION[getValueOrField(duration, ENTER) as Duration],
    ease: EASING[getValueOrField(easing, ENTER) as Easing],
    delay: DURATION[getValueOrField(delay, ENTER) as Duration],
});

const getExitTiming = (duration: DurationType = 'moderate2', easing: EasingType = 'easeOut', delay?: DurationType) => ({
    duration: DURATION[getValueOrField(duration, EXIT) as Duration],
    ease: EASING[getValueOrField(easing, EXIT) as Easing],
    delay: DURATION[getValueOrField(delay, EXIT) as Duration],
});

const variants: VariantsType<SlideProps> = {
    enter: ({ direction, delay, duration, easing }) => {
        const { enter: enterStyles } = slideTransition(direction);
        return {
            ...enterStyles,
            timing: getEnterTiming(duration, easing, delay),
        };
    },
    exit: ({ direction, delay, duration, easing }) => {
        const { exit: exitStyles } = slideTransition(direction);
        return {
            ...exitStyles,
            timing: getExitTiming(duration, easing, delay),
        };
    },
};

export default variants;
